import {
  History as HistoryIcon,
  Person as PersonIcon,
  ShowChart as ShowChartIcon,
  AttachMoney as AttachMoneyIcon,
  Gavel as GavelIcon,
  Face as FaceIcon,
  LocalShipping as LocalShippingIcon,
  HowToReg as HowToRegIcon,
} from '@material-ui/icons';

export const form = {
  commentSb: 'Плохая кредитная история, отказываю в выдаче и требую повторного собрания',
  analysisOfFinancialIndicators: 'Необходимо доработка показателей',
  sourceOfFinancing: 'Плохая кредитная история, отказываю в выдаче',
  courtAndEnforcementProceedings: 'Необходимо доработка показателей',
  workHistory: 'Плохая кредитная история, отказываю в выдаче',
  awarenessTm: 'Необходимо доработка показателей',
  leadershipExperience: 'Плохая кредитная история, отказываю в выдаче',
  workEnvironment: 'Необходимо доработка показателей',
};

export const icons = {
  finAnalysis: ShowChartIcon,
  sbComment: PersonIcon,
  finSource: AttachMoneyIcon,
  courts: GavelIcon,
  history: HistoryIcon,
  tmKnowladge: FaceIcon,
  sbTrip: LocalShippingIcon,
  propCheck: HowToRegIcon,
};

export const reportItems = Object.keys(icons);
